import { postOrdersOrderIdCharges } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { getOrderDetailQueryKey } from "Order/Api/Query/useOrderDetailQuery";
import { getOrderChargeListQueryKey } from "Order/Modules/Payment/Api/Query/useOrderChargeListQuery";
import { getOrderChargesSumQueryKey } from "Order/Modules/Payment/Api/Query/useOrderChargesSumQuery";
import { getOrderFeeQueryKey } from "Order/Modules/Payment/Api/Query/useOrderFeeQuery";
import { getOrderPaymentDetailQueryKey } from "Order/Modules/Payment/Api/Query/useOrderPaymentDetailQuery";
import type { OrderChargePayload } from "Order/Modules/Payment/Types/orderCharge";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

const paymentMutationsResource = Resources.base.payment.mutation;

export const useCreateChargeMutation = (orderId: number) => {
	const { t } = useResource();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse((data: OrderChargePayload) =>
			postOrdersOrderIdCharges(data, orderId),
		),
		onError: (error) => {
			console.error(
				`${t(paymentMutationsResource.createChargeMutationError)}:`,
				error,
			);
		},
		onSuccess: () => {
			toast.success(t(paymentMutationsResource.createChargeMutationSuccess));
			queryClient.invalidateQueries({
				queryKey: getOrderChargeListQueryKey(orderId),
			});
			queryClient.invalidateQueries({
				queryKey: getOrderChargesSumQueryKey(orderId),
			});
			queryClient.invalidateQueries({
				queryKey: getOrderPaymentDetailQueryKey(orderId),
			});
			queryClient.invalidateQueries({
				queryKey: getOrderFeeQueryKey(orderId),
			});
			queryClient.invalidateQueries({
				queryKey: getOrderDetailQueryKey(orderId),
			});
		},
	});
};
